import React, { useState, useEffect, useRef } from "react";

import Competitor from "components/presentation/Competitor";
import Noc from "components/presentation/Noc";
import DateTime from "components/presentation/DateTime"
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import { usePrevious } from "./common"
import Card from 'react-bootstrap/Card';
import Status from "components/presentation/Status";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { getDateTimeFormat } from "helpers/utils";
import SvgMirs from "components/presentation/SvgMirs";

export function ScoreBlock(competitor) {
    const irm = competitor.showIRM && <div className='score-cards'><b>{competitor?.cp_irm}</b></div>
    const resultItem = competitor?.resultItem;
    /**
                   "sortOrder": 1,
                      "itemType": "T",
                      "bib": 0,
                      "resultType": "POINTS",
                      "resultRank": 0,
                      "resultIrm": "",
                      "resultWLT": " ",
                      "resultData": "45"
     */
    const winner = resultItem?.resultWLT === 'W' && <div className='score-winner'> <SvgMirs className='mirsIcon score-winner' title='HeaderWinner' code='circle-check' /></div>
    const [isLoading, setLoading] = useState(false);
    const result = resultItem?.resultData; //competitor.cp_result );
    const prevResult = usePrevious({ result });

    //console.log('COMPONENT PREV-USE: ' + prevResult)
    function loadingTime() {
        return new Promise((resolve) => setTimeout(resolve, 4000));
    }
    useEffect(() => {
        if (isLoading) {
            loadingTime().then(() => {
                setLoading(false);
            });
        }
    }, [isLoading]);


    useEffect(() => {
        if (prevResult && (prevResult !== result)) {
            setLoading(true)
        }

    }, [result])


    return (
        <div className='score-result-container  d-flex flex-row justify-content-end'>
            <div className={`score-result text-end fw-bold ${isLoading ? 'score-result-update' : ''}`}>{result}</div>
            {irm}
        </div>
    )
}

export function CompetitorBlockWinner(props) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let bolding = props?.cp_wlt === 'W' ? ' fw-bold' : '';
    if (props?.boldWinner === false) {
        bolding = '';
    }
    const isTeam = props?.participant?.__typename === 'Team'
    return (
        <div discipline={mirs_discipline} className={'score-competitor-container  d-flex flex-row justify-content-start' + bolding}>
            {/*<div className='score-uniform score-uniform-home'></div>*/}

            <div className='score-noc'>

                {mirs_discipline === 'JUD' || mirs_discipline === 'HOC'
                    ? <Noc className='me-1' {...props?.participant?.organisation} showImgAlt={isTeam ? false : true} />
                    : <Noc className='me-1' {...props?.participant?.organisation} showOnlyImage={true} showImgAlt={isTeam ? false : true} />
                }

            </div>
            <div className={mirs_discipline === 'WRE' ? 'score-name w-50' : 'score-name '} ><Competitor  {...props?.participant} hideNoc={true} hidePicture={true} noLink={true} onlyShortName={true} screen={props.screen} /> </div>
        </div>
    )
}

export function CompetitorBlock(props) {
    return (
        <CompetitorBlockWinner {...props} boldWinner={false} />
    )
}

export function CompetitorBlockNoData(competitor) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let competitorPlace = competitor?.cp_code ? <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitor?.cp_code} notFound={<>&nbsp;</>} /> : ''
    return (
        <div className=' d-flex flex-row justify-content-start'>
            <div></div>
            {/*<div className='score-uniform score-uniform-home'></div>*/}
            <div className=''>{competitorPlace ? competitorPlace : competitor?.cp_prev_pos}</div>
            {/* <div className='score-name'>{competitor?.cp_prev_pos}  </div>*/}
        </div>
    )
}

export function Footer({ data }) {

    const formatDate = getDateTimeFormat('DayMonthShort')
    const formatDateTime = getDateTimeFormat('DayMonthShortHourMinute');

    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} />, <SportCode entity='@CompetitorPlace' code="TBD" abbr={true} /></>
    const dateComponent = data?.bi_time ? dateTimeFormated : date
    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status justify-content-end'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            {isLessLiveStatus(data?.result?.status?.code) && <div className='text-start'>{dateComponent}</div>}
        </>
    )
}

export function Header({ data, bracket, phase }) {
    return (
        <Card.Header className={data?.code !== 'CLEAN' && phase === 'FNL-' ? 'visible' : 'invisible'}>
            <div className='score-header'>
                <b><span>{data?.eventUnit?.shortDescription}</span></b>
            </div>
        </Card.Header>
    )
}

/**
 * By default no headers needed, only sport specific
 * @param {*} param0 
 * @returns 
 */
export function CompetitorHeader({ data, bracket, phase }) {
    return (
        ''
    )
}